import { createSlice } from '@reduxjs/toolkit'
import moment from "moment";

const initialState = {
    expenseTable:{},
    totalExpense: 0,
    is_filter_load:false
}

const ExpenseSlice = createSlice({
    name:"expenseTable",
    initialState:initialState,
    reducers: {
        filterLoad:(state,action)=>{
            state.is_filter_load = action.payload
        },
        showExpenseTable: (state, action) => {
            action.payload.map((item) => (
                item.start_date = moment(item.date).format("DD.MM.YYYY"),
                item.end_date = moment(item.date).format("DD.MM.YYYY")
            ))
            state.expenseTable = action.payload
        },
        showTotalExpense: (state, action) => {
            state.totalExpense = action.payload
        }
    }
})

export const { showExpenseTable, showTotalExpense,filterLoad } = ExpenseSlice.actions

export default ExpenseSlice.reducer